import { DEBUG } from "../../config";
import { updateHeartBeat } from "app/utils/app-record-management";

//
// Actions
// ------------------------------------------------------------------

export const HEARTBEAT = "extras/HEARTBEAT";
export const SET_HEARTBEAT = "extras/SET_HEARTBEAT";

//
// Helpers
// ------------------------------------------------------------------

export const setHeartBeat = (data, newData) => async dispatch => {
  if (DEBUG) {
    console.log("[P] Server - Reducers - Extras: Set heartbeat");
  }
  try {
    let heartBeatData = "";

    if (!newData) {
      heartBeatData = await updateHeartBeat(data);
    } else {
      heartBeatData = newData;
    }

    dispatch({
      type: HEARTBEAT,
      payload: heartBeatData
    });
    return heartBeatData;
  } catch (error) {
    console.error("Error setting heartbeat:", error);

    throw error;
  }
};

//
// Reducer
// ------------------------------------------------------------------

const initialState = {
  data: undefined
};

const extrasReducer = (state = initialState, action) => {
  if (DEBUG) {
    // console.log('[P] Server - Reducers - Auth reducer: Action', action);
  }

  switch (action.type) {
    case HEARTBEAT:
      return {
        ...state,
        heartBeatData: action.payload
      };

    case SET_HEARTBEAT:
      return {
        ...state,
        heartBeatData: action.payload
      };

    default:
      return state;
  }
};

export default extrasReducer;

